module.exports = "/legacy/38dab3adfaee8c1f10ed4eee946299fd.svg";